export const toStringTime = (time: string) => {
  const hour = time?.split(":")?.[0];
  const stringTime = time?.slice(0, -3);
  if (Number(hour) < 12) return `${stringTime}  قبل از ظهر `;
  if (Number(hour) > 12)
    return `${Number(hour) - 12}:${time.split(":")?.[1]}   بعد از ظهر`;
  return `${stringTime} ظهر `;
};
